module.exports = __webpack_public_path__ + "src/images/img/avatar.8a809234.png";